import * as React from "react";
import {styled} from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import {IOrderDetail} from "../models/IOrderDetail";
import {IProduct} from "../models/IProduct";
import {ProductModal} from "./ProductModal";

const Item = styled(Paper)(({theme}) => ({
	backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: "center",
	color: theme.palette.text.secondary,
}));

export function PolicyDetailsGrid(props: { order: IOrderDetail; products: IProduct[] }) {
	if (!props.order.package)
		return (<div></div>);
	
	const order = props.order;
	const orderPackage = order.package;
	const details = orderPackage?.policyDetails;
	if (!details)
		return (<div></div>);
	
	return (
		<Box sx={{flexGrow: 1}}>
			<Grid container spacing={2}>
				<Grid xs={12} md={5} lg={4}>
					<Item>Package</Item>
					<Item>{orderPackage?.customProperties?.externalId ?? ""}</Item>
					<Item>{orderPackage?.productDescription ?? ""}</Item>
					<Item>{orderPackage?.totalInstallmentAmount ?? ""}</Item>
					<Item><ProductModal
						product={props.products.find(x => x.krn === orderPackage?.customProperties?.productKrn)}/></Item>
				</Grid>
				{details.map((policyDetail, index) => (
					<Grid xs={12} md={5} lg={4} key={index}>
						<Item>ProductDescription: {policyDetail.productDescription}</Item>
						<Item>TotalInstallmentAmount: {policyDetail.totalInstallmentAmount ?? 0}</Item>
						<Item>FinancialStatus: {policyDetail.financial?.financialStatus ?? "Unkown"}</Item>
						<Item><ProductModal
							product={props.products.find(x => x.krn === policyDetail.customProperties?.productKrn)}/></Item>
					</Grid>
				))}
				
				<Grid
					xs={12}
					container
					justifyContent="space-between"
					alignItems="center"
					flexDirection={{xs: "column", sm: "row"}}
					sx={{fontSize: "12px"}}
				>
				
				</Grid>
			</Grid>
		</Box>
	);
}
